import { render, staticRenderFns } from "./FlashMessageContainer.vue?vue&type=template&id=32537e47&"
import script from "./FlashMessageContainer.vue?vue&type=script&lang=js&"
export * from "./FlashMessageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32537e47')) {
      api.createRecord('32537e47', component.options)
    } else {
      api.reload('32537e47', component.options)
    }
    module.hot.accept("./FlashMessageContainer.vue?vue&type=template&id=32537e47&", function () {
      api.rerender('32537e47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/layout/FlashMessageContainer.vue"
export default component.exports